import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import GetJobId from "../../../../_utilities/GetJobId";
import { getWorkonDate } from "../../../../_utilities/GetTimeZone";
import { decrypt, Encrypt } from "../../../../_utilities/_encryptDecryptHelper";
import { setBreadCrumb } from "../../../../_utilities/breadCrumb";
import {
  getAttributes,
  getUserDetails,
  GetUserInfo,
} from "../../../../_utilities/getUserInfo";
import ApplicantDetailsComponent from "./../ApplicantDetailsComponent";
import "../ApplicantDetailsCreate/ApplicantDetailsCreate.css";
import { safeJSONParse } from "../../../../_utilities/constants";

const initalState = { data: null, message: "", isloader: true };

const ApplicantDetailsEdit = ({ data, overridestate, onReceiveProps }) => {
  const [getDetails, setGetDetails] = useState(initialDetails);
  const getJobCode = data?.id;
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [overwrideObj, setOverwrideObj] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    console.log(overwrideObj);
  }, [overwrideObj]);

  const ApplicantData = data; //useSelector((state) => state.ApplicantsById.data);
  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );
  const DocId = useSelector((state) => state.UploadDocuments.docId);
  const AddAssociatedjobs = useSelector((state) => state.AddAssociatedjobs.data);
  const { storedApplicant } = useSelector((state) => state.SelectedApplicant);

  useEffect(() => {
    if (data) {
      setGetDetails(data);
    }
  }, [data]);

  useEffect(() => {
    if (!overridestate?.applicant || !overridestate.isOverwriteEdit) return;

    const applicant = overridestate.applicant;

    /* ---------- Education Details ---------- */
    const educationDetails = Array.isArray(applicant.educationDetails)
      ? applicant.educationDetails.map((item, index) => ({
          ...item,
          id: index,
          isEdit: false,
          startDate: item?.startDate
            ? new Date(item.startDate).toLocaleDateString()
            : "",
          endDate: item?.endDate
            ? new Date(item.endDate).toLocaleDateString()
            : "",
          degree: item?.education ?? item?.degree,
        }))
      : [];

    /* ---------- Work Experience ---------- */
    const rawWorkExp = applicant.workExp || applicant.workExperiences || [];

    const workExp = Array.isArray(rawWorkExp)
      ? rawWorkExp.map((item, index) => ({
          ...item,
          id: index,
          isEdit: false,
          locationFormated: item?.location?.formatted ?? "",
          startDate: item?.startDate
            ? new Date(item.startDate).toLocaleDateString()
            : "",
          endDate: item?.endDate
            ? new Date(item.endDate).toLocaleDateString()
            : "",
        }))
      : [];

    /* ---------- Applicants Object ---------- */
    const Applicants = {
      ...applicant.Applicants,
      contactNumber:
        applicant.Applicants?.contactNumber ??
        applicant.Applicants?.phone ??
        "",
      resumesourceId:
        applicant.resumesource ??
        applicant.sourceId?.id ??
        applicant.Applicants?.resumesourceId ??
        applicant.Applicants?.resumeSourceId,
      resumesource:
        applicant.resumesource ??
        applicant.sourceId?.name ??
        applicant.Applicants?.resumesourceId ??
        applicant.Applicants?.resumeSource,
      candidateStatus: applicant.Applicants?.candidateStatus ?? "",
    };

    /* ---------- Final Object ---------- */
    const newObj = {
      ...applicant,
      educationDetails,
      workExp,
      Applicants,
      applicantCode:
        applicant?.applicantCode ?? ApplicantData?.[0]?.applicantCode,
      identifier: applicant.identifier,
      rawData: applicant?.rawData ?? ApplicantData?.rawData ?? "",
      formattedLocation: applicant?.locationData?.formatted ?? "",
      locationRawInput: applicant?.locationData?.locationRawInput ?? "",
      latitude: applicant?.locationData?.latitude ?? null,
      longitude: applicant?.locationData?.longitude ?? null,
      locationCity: applicant?.locationData?.city ?? "",
      locationCountry: applicant?.locationData?.country ?? "",
      locationState: applicant?.locationData?.state ?? "",
    };

    /* ---------- Persist ---------- */
    // localStorage.setItem("OverwriteEditObj", JSON.stringify(newObj));
    setOverwrideObj(newObj);

    /* ---------- Breadcrumb / Sidebar ---------- */
    const designation =
      workExp.length > 0
        ? `${workExp[0]?.jobTitle || ""}${
            workExp[0]?.organization ? " / " + workExp[0]?.organization : ""
          }`
        : "";

    const expObject = workExp[0]?.experienceInMonths
      ? workExp[0]?.experienceInMonths
      : {
          startDate: workExp[0]?.startDate,
          endDate: workExp[0]?.isCurrent ? "present" : workExp[0]?.endDate,
        };

    const additionalData = {
      applicantName: `${Applicants.firstName} ${Applicants.lastName}`,
      currentWorking: {
        designation,
        from: getWorkonDate(expObject, "level2"),
      },
      emailId: Applicants?.emailId,
      contactNumber: Applicants?.contactNumber || Applicants?.phone,
      alternateContactNumber: Applicants?.alternateContactNumber || "",
      linkedIn: applicant.linkedIn ?? "",
      location: applicant?.locationData?.formatted ?? "",
    };

    setBreadCrumb(
      newObj.id,
      additionalData.applicantName,
      "Applicant Code",
      additionalData,
    );
  }, [overridestate, ApplicantData]);

  const Editdata = useSelector((state) => state.EditApplicants.data);

  const GetValidData = async (data) => {
    const userData = await GetUserInfo();
    // dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
    let finalObj = data;
    finalObj = { ...data, ...data.Applicants };
    finalObj["id"] = getJobCode;
    finalObj.educationDetails = JSON.stringify(data.educationDetails);
    finalObj.workExp = JSON.stringify(data.workExp);
    finalObj.certification = JSON.stringify(data.certification);
    finalObj.skillDetails = JSON.stringify(data.skillDetails);
    finalObj.customFields = data.customFields;
    finalObj.applicantCode = data && data.applicantCode;
    const userInfo = await getUserDetails();
    finalObj["userFirstName"] = userInfo.firstName
      ? userInfo.firstName
      : data.firstName;
    finalObj["userLastName"] = userInfo.lastName
      ? userInfo.lastName
      : data.lastName;
    finalObj["userId"] = userInfo.userId;
    finalObj["linkedIn"] = data.linkedIn ?? "";
    finalObj["formattedLocation"] = data?.formattedLocation ?? "";
    finalObj["locationRawInput"] = data?.locationRawInput ?? "";
    finalObj["locationCity"] = data?.locationCity ?? "";
    finalObj["locationCountry"] = data?.locationCountry ?? "";
    finalObj["locationState"] = data?.locationState ?? "";
    finalObj["latitude"] = data?.latitude ?? "";
    finalObj["longitude"] = data?.longitude ?? "";
    finalObj["rawData"] = data?.rawData ?? ApplicantData.rawData;
    // const overwrideObj = safeJSONParse(
    //   localStorage.getItem('OverwriteEditObj')
    // );
    if (overwrideObj !== null) {
      const userInfo = await getUserDetails();
      if (overwrideObj.Resume && overwrideObj.Applicants.resumesourceId) {
        let formData = new FormData();
        formData.append("Resume", overwrideObj.Resume);
        formData.append("id", getJobCode);
        formData.append("userId", userInfo.userId);
        formData.append("DbUserId", userData[0].userId);
        formData.append("ResumeUserId", userData[0].userId);
        formData.append("fileType", "Resume");
        formData.append(
          "resumesourceId",
          overwrideObj.Applicants.resumesourceId,
        );
        formData.append("resumesource", overwrideObj.Applicants.resumesource);
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        formData.append("linkedIn", overwrideObj.linkedIn ?? "");
        formData.append("primaryResume", 1);
        formData.append(
          "formattedLocation",
          overwrideObj.formattedLocation ?? "",
        );
        formData.append("locationCity", overwrideObj.locationCity ?? "");
        formData.append("locationCountry", overwrideObj.locationCountry ?? "");
        formData.append("locationState", overwrideObj.locationState ?? "");
        formData.append(
          "locationRawInput",
          overwrideObj.locationRawInput ?? "",
        );
        formData.append("latitude", overwrideObj.latitude ?? "");
        formData.append("rawData", overwrideObj.rawData ?? "");
        formData.append("longitude", overwrideObj.longitude ?? "");
        dispatch(_ser.uploadDocumentsAsync(getJobCode, formData, true));
      } else {
        //  for making document as primary
        let formData = new FormData();
        formData.append("applicantId", getJobCode);
        formData.append("applicantCode", storedApplicant?.applicantCode);
        formData.append("userId", userInfo.userId);
        dispatch(_ser.setPrimaryDocumentAsync(overridestate?.docId, formData));
      }
    }
    dispatch(_ser.editApplicantsAsync(getJobCode, finalObj))
    .then(() => {
      setDisableSubmitBtn(false);
    })
    .catch(() => {
      setDisableSubmitBtn(false);
    });
    let designation =
      data.workExp?.length > 0
        ? `${data.workExp[0]?.jobTitle || ""}${data.workExp[0]?.organization ? " / " + data.workExp[0]?.organization : ""}`
        : "";
    let expObject = data.workExp[0]?.experienceInMonths
      ? data.workExp[0]?.experienceInMonths
      : {
          startDate: data.workExp[0]?.startDate,
          endDate: Boolean(data.workExp[0]?.isCurrent)
            ? "present"
            : data.workExp[0]?.endDate,
        };
    let additionalData = {
      applicantName: `${data.Applicants.firstName} ${data.Applicants.lastName}`,
      currentWorking: {
        designation: designation,
        from: getWorkonDate(expObject, "level2"),
      },
      emailId: data.Applicants?.emailId,
      contactNumber: data.Applicants?.contactNumber || data.Applicants?.phone,
      alternateContactNumber: data.Applicants?.alternateContactNumber || "",
      linkedIn: data.linkedIn ?? "",
      location: data?.formattedLocation?.trim() || 
          [data?.locationCity, data?.locationState, data?.locationCountry]
              .filter(Boolean).join(", "),
    };
    setBreadCrumb(
      getJobCode,
      additionalData.applicantName,
      "Applicant Code",
      additionalData,
    );
  };

  useEffect(() => {
    if (Editdata === 200) {
      dispatch(_ser.editApplicantsStartReducer(initalState));
      dispatch(_ser.applicantsByIdStartReducer(initalState));
      if (!selectedJobDetails) {
        setTimeout(() => {
          // navigate(`/ats/layout/applicants/view/${getJobCode}`);
          onReceiveProps("loadApplicant", "resetTabs");
        }, 1000);
      }
    }
  }, [Editdata]);

  const processApplicantjobs = async (docId) => {
      if (
        docId &&
        !location.state?.isAssociatedApplicant &&
        selectedJobDetails?.length > 0
      ) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();

        let data = {
          id: getJobCode,
          jobCode: selectedJobDetails[0].jobCode,
          docId: docId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        dispatch(_ser.uploadDocumentsStartReducer(initalState));
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(_ser.addAssociatedjobsAsync(getJobCode, data, "posting"));
        dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
        localStorage.removeItem("OverwriteEditObj");
        // onReceiveProps("loadApplicant");
      }
    }

  useEffect(() => {
    if(DocId){
      processApplicantjobs(DocId);
    }
  }, [DocId]);

  useEffect(() => {
    if(AddAssociatedjobs){
      onReceiveProps("loadApplicant");
    }
  }, [AddAssociatedjobs]);

  const actionBtns = [
    {
      variant: "text",
      style: { color: "red", width: "6rem", fontWeight: "bolder" },
      navigateTo: () =>{
        const isPrimaryDoc = JSON.parse(localStorage.getItem("isPrimaryDoc"))
        onReceiveProps(overwrideObj != null && !isPrimaryDoc ? "clear" : "loadApplicant");
        localStorage.removeItem("isPrimaryDoc");
        navigate(location.pathname + location.search, {
          state: { selectedApplicant: overwrideObj ?? getDetails },
        });
      },
      label: "Cancel",
      type: "back",
      class: "buttonHover",
    },
    {
      variant: "contained",
      style: {
        backgroundColor: "var(--primary-bg-color)",
        color: "var(--primary-background-text-color)",
        borderRadius: "10px",
        width: "6rem",
        fontSize: "14px",
      },
      navigateTo: null,
      label: "Save",
      type: "submit",
      class: "buttonHover1",
    },
  ];

  return (
    <React.Fragment>
      <div style={{ padding: "0 10px" }} id="applicantsView">
        <ApplicantDetailsComponent
          componentType="Edit"
          input={overwrideObj ?? getDetails}
          iniValue={initialDetails}
          actions={actionBtns}
          onValidData={GetValidData}
          disableSubmitBtn={disableSubmitBtn}
        />
      </div>
    </React.Fragment>
  );
};

export default ApplicantDetailsEdit;

const initialDetails = {
  Applicants: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    alternateContactNumber: "",
    emailId: "",
  },
  educationDetails: [
    { id: "", education: "", startDate: null, endDate: null, location: "" },
  ],
  workExp: [
    {
      id: "",
      organization: "",
      jobTitle: "",
      industry: "",
      startDate: null,
      endDate: null,
      isCurrent: "",
      location: "",
      jobDescription: "",
    },
  ],
  formattedLocation: null,
  locationCity: null,
  locationCountry: null,
  locationState: null,
  locationRawInput: null,
  latitude: null,
  longitude: null,
  skillDetails: [],
  certification: [],
  totalExperience: null,
  linkedIn: "",
  id: 0,
  userId: "",
  customFields: "",
  firstName: "",
  lastName: "",
  identifier: "",
  applicantCode: "",
  customerId: 0,
  source: "ATS",
  resumesourceId: "",
  candidateStatus: "",
  applicantCode: "",
  csAssociatedJobs: "",
  eAssociatedJobs: "",
  vsAssociatedJobs: "",
  Resume: null,
  rawData: "",
};
